import { makeStyles } from "@material-ui/core";
import { BASE_URL_4, DEFAULT_BOX_SHADOW, instance2, instance4, PRIMARY_BACKGROUND } from "App/constants";
import fileDownload from "js-file-download";

export const urlPembayaran ="/wmsAsset/pembayaran/list-byid-pembelian";
export const getAllKelasKamar = async () => {
  try {
    const api = await instance2.get("/bed/listkelaskamar");
    const res = api.data;
    return res.body;
  } catch (error) {
    return false;
  }
};

export const urlGetFile = "/wmsAsset/asset/list-file-id";
export const urlUpload ="/wmsAsset/asset/upload-file";
export const urlDelete ="/wmsAsset/asset/delete-file";
export const urlDownload ="/wmsAsset/asset/download-file";

export const downloadPDF = async (id, fileName) => {
  try {
    const api = await instance4.get(`${BASE_URL_4+urlDownload}/${id}`, {
      responseType: "blob",
    });
      fileDownload(api.data, fileName);
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    };
  }
};

export const STYLE_MASTER_FA = makeStyles({
  root: {
    width: "auto",
  },
  paper: {
    width: "100%",
    margin: "0",
    padding: "1rem 1.5rem",
    backgroundColor: PRIMARY_BACKGROUND,
    boxShadow: DEFAULT_BOX_SHADOW,
  },
  table: {
    width: "100%",
    margin: "0 auto",
    overflow: "auto",
  },
});


export const headCells = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
  },
  {
    id: "id",
    disablePadding: false,
    label: "ID",
    align: "left",
  },
  {
    id: "pembelian_id",
    disablePadding: false,
    label: "PEMBELIAN ID",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "nama_supplier",
    disablePadding: false,
    label: "NAMA SUPPLIER",
    align: "left",
    minWidth: "200px",
  },
  {
    id: "no_faktur",
    disablePadding: false,
    label: "NO. FAKTUR",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "idgl",
    disablePadding: false,
    label: "IDGL",
    align: "left",
    minWidth: "100px",
  },
  {
    id: "tanggal_masuk",
    disablePadding: false,
    label: "TANGGAL",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "jumlah_bayar",
    disablePadding: false,
    label: "JUMLAH BAYAR",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "namaKas",
    disablePadding: false,
    label: "KAS",
    sort: false,
    align: "left",
    minWidth: "170px",
  },
  {
    id: "tipe_pembayaran_id",
    disablePadding: false,
    label: "TIPE PEMBAYARAN",
    sort: false,
    align: "left",
    minWidth: "170px",
  },
  {
    id: "tipe_kartu",
    disablePadding: false,
    label: "TIPE KARTU",
    align: "left",
    minWidth: "170px",
  },
  {
    id: "no_kartu",
    disablePadding: false,
    label: "NO KARTU",
    align: "left",
    minWidth: "170px",
  },
  {
    id: "no_transfer",
    disablePadding: false,
    label: "NO TRANSFER",
    align: "left",
    minWidth: "170px",
  },
  {
    id: "createdAt",
    disablePadding: false,
    label: "INSERTED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "createdBy",
    disablePadding: false,
    label: "INSERTED BY",
    sort: false,
    minWidth: "150px",
  },
  {
    id: "updatedAt",
    disablePadding: false,
    label: "UPDATED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "updatedBy",
    disablePadding: false,
    label: "UPDATED BY",
    sort: false,
    minWidth: "150px",
  },
];

export const headCellsFile = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
    maxWidth: "80px",
  },
  {
    id: "act",
    disablePadding: false,
    label: "ACTION",
    align: "left",
    sort: false,
  },
  {
    id: "id",
    disablePadding: false,
    label: "ID",
    align: "center",
    sort: true,
    maxWidth: "80px",
  },
  {
    id: "name",
    disablePadding: false,
    label: "NAMA FILE",
    align: "left",
    sort: true,
    minWidth: "400px",
  },
  {
    id: "remark",
    disablePadding: false,
    label: "CATATAN",
    align: "left",
    sort: false,
    minWidth: "400px",
  },
];
